var imegaCategory = imegaCategory || (function($) {

  var baseUrl='https://angus.finance-calculator.co.uk/api/public/';
  var apiKey;
  var insertMethod;
  var holderSelector;
  var outerSelector;
  var priceSelector;
  var positionSelector;
  var financeOptions;
  var currencySymbol = '£';
  var styleCss;
  var messagePrefix = 'From ';
  var messageSuffix = '/Month';
  var deposit;
  var monthlyAmount;

  return {
    init: function(options){
      run(options);
    }
  }

  function run(options){
    apiKey = options.apiKey;
    insertMethod = options.insertion;
    outerSelector = options.outerElement;
    priceSelector = options.priceSelector;
    holderSelector = options.holderSelector ? options.holderSelector : false;
    positionSelector = options.positionElement ? options.positionElement : priceSelector;
    styleCss = options.customCss ? options.customCss : false;
    messagePrefix = options.prefix ? options.prefix : messagePrefix;
    messageSuffix = options.suffix ? options.suffix : messageSuffix;
    baseUrl = options.api ? options.api : baseUrl;
    deposit = options.deposit ? parseFloat(options.deposit) : false;
    getFinanceOptions();
  }

  function getFinanceOptions(){
    var requestData = {};
    requestData.api_key = apiKey;
    $.ajax({
      url: baseUrl+'finance-options/all',
      data: requestData
    }).done( function (data, statusText, xhr){
      try{
        financeOptions = data;
        showAmounts();
        if(holderSelector){
          observeDom();
        }
      } catch (error) {
        console.warn('Imegamedia Finance Calculator  : '+error.message);
      }
    }).fail(function (xhr, statusText, error){
      apiResponse = {data:error,text:statusText,xhr:xhr};
      console.warn('Imegamedia Finance Calculator  : Failed to retrieve rates');
    });
  }

  function showAmounts(){
    setCss();
    $(outerSelector).each(function(){
      var financeFilter;
      var price = parseFloat($(priceSelector, this).text().replace(/[^0-9\.-]+/g,""));

      if($('[data-finance-filter]', this).length){
        financeFilter = $('[data-finance-filter]', this).first().attr('data-finance-filter');
      } else{
        financeFilter = 'ALL';
      }


      var monthlyAmount = getMonthlyAmount(price, financeFilter);

      if(monthlyAmount){
        $('.imm-monthly-amount', this).remove();
        var messageHtml = '<span class="imm-monthly-amount">'+messagePrefix+'<span class="imm-monthly-amount-amount">'+monthlyAmount+'</span>'+messageSuffix+'</span>';
        switch(insertMethod){
          case 'before' :
          $(positionSelector, this).before(messageHtml);
          break;
          case 'after'  :
          $(positionSelector, this).after(messageHtml);
          break;
          case 'append' :
          $(positionSelector, this).append(messageHtml);
          break;
          case 'prepend' :
          $(positionSelector, this).prepend(messageHtml);
          break;
          case 'replace' :
          $(positionSelector, this).html(messageHtml);
          break;
          default :
          $(positionSelector, this).after(messageHtml);
        }
      }
    });
  }

  function getMonthlyAmount(price, keyword){
    var financeOption;
    var filterFinanceOptions = financeOptions.filter(filterRatesByMinMax(price)).filter(filterRatesByKeyword(keyword));

    filterFinanceOptions.forEach(function(option){
      option.real_max_deposit = (Math.floor(((1-(option.min_loan / price))*100))/5)*5;
      if(option.real_max_deposit > option.max_deposit){
        option.real_max_deposit = option.max_deposit;
      }
    });

    if(filterFinanceOptions.length){
      financeOption = filterFinanceOptions.reduce(function(prev, current) {
        return (((100-prev.real_max_deposit)*prev['imega_finance_rate'].load_factor) < ((100-current.real_max_deposit)*current['imega_finance_rate'].load_factor)) ? prev : current;
      });
    } else {
      financeOption = false;
    }
    if (financeOption){
      if(deposit){
          monthlyAmount = currencySymbol+Math.ceil((price-deposit)*financeOption['imega_finance_rate'].load_factor);
      } else {
          monthlyAmount = currencySymbol+Math.ceil((price-((financeOption.real_max_deposit/100)*price))*financeOption['imega_finance_rate'].load_factor);
      }
      return monthlyAmount;
    } else{
      return false;
    }
  }

  function filterRatesByMinMax(price){
    return function(option){
      if(price >= parseFloat(option.min_order) && price <= parseFloat(option.max_order)){
        return true;
      } else {
        return false;
      }
    }
  }

  function filterRatesByKeyword(keyword){
    return function(option){
      if(keyword == (option.keyword)){
        return true;
      } else {
        return false;
      }
    }
  }

  function observeDom(){

      var priceObserver = new MutationObserver(function(mutations) {
        showAmounts();
      });
      var config = { childList: true};
      priceObserver.observe($(holderSelector)[0], config);
  }

  function setCss(){
    if(styleCss){
      $('head').append('<style>'+styleCss+'</style>');
    }
  }

})(jQuery);
